import React from "react";

export default function Hero() {
  return (
    <section className="hero">
      <div className="container hero-container">
        <div className="hero-text">
          <span className="badge">Certified English to Arabic Translation in the UK</span>

          <h1>
            Clear, Professional and Reliable Translation for Important Documents
          </h1>

          <p>
            Yaich Translations provides professional English to Arabic
            translation services for legal, official, academic, business and
            personal documents, with a focus on clarity, trust and professional
            presentation.
          </p>

          <div className="hero-buttons">
            <a href="/#quote" className="btn btn-primary">
              Request a Quote
            </a>
            <a href="#services" className="btn btn-secondary">
              View Services
            </a>
          </div>

          <div className="hero-trust-row">
            <span>✔ Certified Translation Focus</span>
            <span>✔ Human Professional Work</span>
            <span>✔ Suitable for Important Documents</span>
          </div>
        </div>

        <div className="hero-card">
          <div className="info-card">
            <div className="credential-badge">English to Arabic Specialist Service</div>
            <h3>Professional Document Translation</h3>
            <p>
              A modern translation service for clients who need confidence,
              clarity and a professional standard for important paperwork.
            </p>

            <div className="mini-stats">
              <div className="mini-stat">
                <strong>Legal & Official</strong>
                <span>Document Focus</span>
              </div>

              <div className="mini-stat">
                <strong>Professional</strong>
                <span>Clear Presentation</span>
              </div>

              <div className="mini-stat">
                <strong>UK Market</strong>
                <span>Client-Oriented Positioning</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}